export default __webpack_public_path__ + "images/e6a44569583230b2cca52def40b994ad-fall_banner_desktop.webp";